module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--09.cb4b2d8e.png";